// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parallax-body .parallax {
  top: 0;
  left: 0;
  object-fit: cover;
  right: 0;
  height: 150vh;
  z-index: 998;
}

.parallax-body .text-img {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  height: auto;
  object-fit: contain;
}
.parallax-body .intro {
  position: absolute;
  top: 30%;
  left: 90%;
  transform: translate(-50%, -50%);
  width: 50%;
  height: auto;
  object-fit: contain;
  z-index: 9999999 !important;
}
.parallax-body .bg-img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center !important;
}
@media (min-width:1000px) and (max-width:1400px) {
  .parallax-body .intro {
    position: absolute;
    top: 50% !important;
    left: 80% !important;
    transform: translate(-50%, -50%);
    width: 50%;
    height: auto;
    object-fit: contain;
    z-index: 9999999 !important;
  }
}
@media (max-width:767px) {
  .parallax-body .intro {
    position: absolute;
    top: 40%;
    left: 50% !important;
    transform: translate(-50%, -50%);
    width: 30% !important;
    height: auto;
    object-fit: contain;
    z-index: 9999999 !important;
  }
  .parallax-body .bg-img {
    background-position: left !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/components/parallaxFirst.css"],"names":[],"mappings":"AAAA;EACE,MAAM;EACN,OAAO;EACP,iBAAiB;EACjB,QAAQ;EACR,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,uCAAuC;EACvC,iCAAiC;EACjC,sCAAsC;AACxC;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,gCAAgC;IAChC,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;EAC7B;EACA;IACE,oCAAoC;EACtC;AACF","sourcesContent":[".parallax-body .parallax {\n  top: 0;\n  left: 0;\n  object-fit: cover;\n  right: 0;\n  height: 150vh;\n  z-index: 998;\n}\n\n.parallax-body .text-img {\n  position: absolute;\n  top: 30%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 50%;\n  height: auto;\n  object-fit: contain;\n}\n.parallax-body .intro {\n  position: absolute;\n  top: 30%;\n  left: 90%;\n  transform: translate(-50%, -50%);\n  width: 50%;\n  height: auto;\n  object-fit: contain;\n  z-index: 9999999 !important;\n}\n.parallax-body .bg-img {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover !important;\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  background-position: center !important;\n}\n@media (min-width:1000px) and (max-width:1400px) {\n  .parallax-body .intro {\n    position: absolute;\n    top: 50% !important;\n    left: 80% !important;\n    transform: translate(-50%, -50%);\n    width: 50%;\n    height: auto;\n    object-fit: contain;\n    z-index: 9999999 !important;\n  }\n}\n@media (max-width:767px) {\n  .parallax-body .intro {\n    position: absolute;\n    top: 40%;\n    left: 50% !important;\n    transform: translate(-50%, -50%);\n    width: 30% !important;\n    height: auto;\n    object-fit: contain;\n    z-index: 9999999 !important;\n  }\n  .parallax-body .bg-img {\n    background-position: left !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
